import {GetterTree} from 'vuex'
import {PartnerUsersState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<PartnerUsersState, RootState> = {
  partnerUsers(state) {
    return state.partnerUsers;
  },
  partnerUserItem(state) {
    return state.partnerUserItem;
  },
};
